import { PagedSingleSelectField, SelectSingleChangeHandler, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { organizationalUnitService } from "../api/organizationalUnitService";
import { OrganizationalUnitOptionResource } from "../types/organizationalUnit";

interface Props {
	name: string;
	label: string;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
	onChange?: SelectSingleChangeHandler<OrganizationalUnitOptionResource | null>;
}

const fetchConfig = laravelServiceSelectFetchConfig(organizationalUnitService);

export const OrganizationalUnitSingleSelectField: FC<Props> = ({
	name,
	label,
	required,
	onChange,
	disabled,
	clearable = true,
}) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			fetchConfig={fetchConfig}
			onChange={onChange}
		/>
	);
};
